import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileIndustry",
  props: {
    industryData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      expanded: false
    };
  },
  computed: {
    flatIndustryData: function flatIndustryData() {
      var result = [];
      (this.industryData || []).forEach(function (group) {
        (group || []).forEach(function (item) {
          result.push(item);
        });
      });
      return result;
    },
    displayData: function displayData() {
      if (this.expanded) return this.flatIndustryData;
      return this.flatIndustryData.slice(0, 3);
    },
    cssVars: function cssVars() {
      return {
        "--mi-spacing": "16px",
        "--mi-radius": "12px",
        "--mi-radius-sm": "8px",
        "--mi-font-base": "14px",
        "--mi-title-color": "#133583",
        "--mi-text-secondary": "#90A1C7",
        "--mi-primary": "#1668f4",
        "--mi-primary-light": "#e8f0fe",
        "--mi-border": "#e8edf5",
        "--mi-shadow": "0 2px 12px 0 rgba(10, 61, 145, 0.08)",
        "--mi-padding-top": "20px",
        "--mi-section-title-font-size": "18px",
        "--mi-section-title-mb": "12px",
        "--mi-section-more-font-size": "13px",
        "--mi-item-padding": "14px",
        "--mi-icon-wrap-size": "36px",
        "--mi-icon-wrap-radius": "8px",
        "--mi-icon-wrap-mr": "12px",
        "--mi-icon-size": "22px",
        "--mi-name-mr": "10px",
        "--mi-count-padding-y": "2px",
        "--mi-count-padding-x": "10px",
        "--mi-count-radius": "10px"
      };
    }
  },
  methods: {
    getIcon: function getIcon(index) {
      var iconIndex = index % 5 + 1;
      try {
        return require("@/assets/newimg/home_three/three_icon_".concat(iconIndex, ".png"));
      } catch (e) {
        return "";
      }
    },
    handleClick: function handleClick(item) {
      this.$router.push({
        path: "/virtual",
        query: {
          courseType: "14"
        }
      });
    },
    toggleMore: function toggleMore() {
      this.expanded = !this.expanded;
    }
  }
};